import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import { getReport } from "src/apis/tickets";
import { getAllAssets, CreateBudget } from "src/apis/complex";
import { MenuItem, Select } from "@mui/material";
import TextField from "@mui/material/TextField";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Box from "@mui/material/Box";

import {
  DialogContent,
  DialogTitle,
  Grid,
  Switch,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import { useAlertContext } from "src/hooks/use-alert";
import "./budgetForm.css";
export default function BudgetForm({ visbile, onClose }) {
  const alert = useAlertContext();
  const [multiline, setMultiline] = useState("");

  const [assets, setAssets] = useState(null);
  const [chosenAsset, setChosenAsset] = useState("");
  const handleChange = (event) => {
    setChosenAsset(event.target.value);
  };

  {
    /**fetch all assets for form */
  }
  useEffect(() => {
    const fetchData = async () => {
      try {
        var assets = await getAllAssets();
        assets = assets.map((asset) => {
          return { id: asset.id, value: asset.name };
        });
        setAssets(assets);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  {
    /** SubmitBudget api call  */
  }
  const SubmitBudget = async (data) => {
    try {
      console.log(data);
      onClose();
      var response = await CreateBudget(data);
      const message = "Budget created succesfully";

      if (response.success) {
        // success alert
        alert.setSuccess((prev) => [
          ...prev,
          {
            status: true,
            message: message,
            index: prev.length,
          },
        ]);
      } else {
        alert.setError((prev) => [
          ...prev,
          { status: true, messages: response.errors, index: prev.length },
        ]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const {
    control,
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  return (
    <Dialog open={visbile} onClose={onClose}>
      <div className="FormContainer">
        <DialogTitle> Set a project </DialogTitle>
        <DialogContent>
          <form>
            <div className="fieldswrapper">
              <Grid container>
                <Grid item md={6} lg={6} sm={12}>
                <div className="inline"> Project Name:</div>
                  <div className="inputContainers">
                    <Controller
                      name="id"
                      control={control}
                      rules={{
                        required: "Please select a Project",
                      }}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <Select
                          sx={{
                            color: "white",
                            height: 37,
                            ".MuiOutlinedInput-notchedOutline": {
                              borderColor: "white",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "white",
                            },
                            ".MuiSvgIcon-root ": {
                              fill: "white !important",
                            },
                          }}
                          value={value}
                          onChange={onChange}
                        >
                          <MenuItem>Project 1</MenuItem>
                        </Select>
                      )}
                    />
                  </div>
                </Grid>
                <Grid item md={6} lg={6} sm={12}>
                <div className="inline">Add Budget : €{" "}</div>
                  <div className="inputContainers">
                    <input
                      type="number"
                      fullWidth
                      name="humidity"
                      {...register("amount", { required: false })}
                    />
                  </div>
                </Grid>

                <Grid item md={6} lg={6} sm={12}>
                  <div className="inline">Start Date: </div>
                  <div className="inline">
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                </Grid>
                <Grid item md={6} lg={6} sm={12}>
                  <div className="inline">End Date: </div>
                  <div className="inline">
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                </Grid>
                <Grid item md={12} lg={12} sm={12}>
                  <div className="inlinetextarea">Description:</div>
                  <div className="inlinetextarea">
                    <TextField
                      multiline
                      value={multiline}
                      onChange={(e) => setMultiline(e.target.value)}
                    />
                  </div>
                </Grid>
                <Grid item xs={6} md={6}>
                  <div className="cancelBudgetProject">
                    <Button variant="text">Cancel</Button>
                  </div>
                </Grid>
                <Grid item xs={6} md={6}>
                  <div className="submitBudgetProject">
                    <Button variant="text">Submit</Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          </form>
        </DialogContent>
      </div>
    </Dialog>
  );
}
